export const createTeamsAPI = (request) => ({
  getCurrentTeam: () => 
    request('/team-get', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
}); 